import { jsx } from "react/jsx-runtime";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { validateTidalLicense } from "../../base/index.js";
function LockOpen(props) {
  return /* @__PURE__ */ jsx(
    LockOpenIcon,
    {
      "data-testid": "LockOpen",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LockOpen",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
LockOpen.tidalIconMeta = {
  categories: "fileActions",
  name: "LockOpen"
};
validateTidalLicense();
export {
  LockOpen
};
//# sourceMappingURL=LockOpen.js.map
